<template>
  <div
      ref="moveDiv"
      :class="{ 'dra-tran': showtran }"
      class="refund_levitate-btn"
      mg-stat-mod="c_hwrecactpop"
      @mousedown="down($event)"
      @mousemove="move($event)"
      @mouseup="end"
      @touchend="end"
      @touchmove="move($event)"
      @touchstart="down($event)"
  >
    <div class="refund_levitate-btn_link" @click="gotoCustomerServiceUrl">
      <img :src="helpImg"/>
      <span>在线客服</span>
    </div>
  </div>
</template>
<script>
import Env from 'utils/env';
import helpImg from 'assets/img/help.png';

export default {
  name: 'refundLevitate',
  data() {
    return {
      Env,
      helpImg,
      flags: false,
      showtran: false,
      position: { x: 0, y: 0 },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      xPum: '',
      yPum: '',
    };
  },
  methods: {
    down($event) {
      this.flags = true;
      let touch;
      if ($event.touches) {
        [touch] = $event.touches;
      } else {
        touch = $event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.moveDiv.offsetLeft;
      this.dy = this.$refs.moveDiv.offsetTop;
    },
    move($event) {
      if (this.flags) {
        let touch;
        if ($event.touches) {
          [touch] = $event.touches;
        } else {
          touch = $event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        this.$refs.moveDiv.style.left = `${this.xPum}px`;
        this.$refs.moveDiv.style.top = `${this.yPum}px`;
        // 阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        document.addEventListener(
          'touchmove',
          () => {
            $event.preventDefault();
          },
          false,
        );
      }
    },
    // 鼠标释放时候的吸附
    end() {
      this.flags = false;
      if (this.xPum) {
        this.showtran = true;
        // 图片的位置
        const moveDivLeft = this.$refs.moveDiv.style.left.replace('px', '');
        // 中心轴的位置
        const middleWidth = this.getParentSize() / 2;
        let moveLeft;
        if (Number(moveDivLeft) + 70 < middleWidth + 21.5) {
          moveLeft = 0;
        } else {
          moveLeft = this.getParentSize() - 70 - 10.75;
        }
        this.$refs.moveDiv.style.left = `${moveLeft - 10}px`;
        setTimeout(() => {
          this.showtran = false;
        }, 200);
      }
    },
    getParentSize() {
      const style = window.getComputedStyle(this.$el.parentNode, null);
      return parseInt(style.getPropertyValue('width'), 10);
    },
    gotoCustomerServiceUrl() {
      window.location.href = process.env.VUE_APP_CUSTOMER_SERVICE_URL;
    },
  },
};
</script>
<style lang="scss" scoped>
.refund_levitate-btn {
  position: fixed;
  right: -20px;
  bottom: 280px;
  width: 180px;
  z-index: 1000;
  display: flex;
  touch-action: none;

  &_link {
    z-index: 1200;
    background-color: rgb(240, 216, 207);
    border-radius: 10px;
    padding: 0px 10px;

    img {
      z-index: 1300;
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }

    font-size: 24px;
    color: rgb(235, 85, 40);;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }

  .delete {
    position: absolute;
    top: -21.5px;
    right: -21.5px;
    width: 43px;
    height: 43px;
  }
}

.dra-tran {
  transition: top 0.2s ease-out, left 0.2s ease-out;
}
</style>

